import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment, HTTP_INTERCEPORTS} from '../environments/environment';
import {AppComponent} from './app.component';
import {APP_RESOLVER_PROVIDERS} from './app.resolver';
import {ROUTES} from './app.routes';
import {ConfirmDialogComponent} from './components/confirm-dialog/confirm-dialog.component';
import {DistributionAccountModule} from './distribution-account/distribution-account.module';
import {DocumentationModule} from './documentation/documentation.module';
import {AuthGuardService} from './guards/auth-guard.service';
import {HomeComponent} from './home/home.component';
import {LogoutComponent} from './logout/logout.component';
import {SharedModule} from './shared.module';
import {NotificationComponent} from './notification/notfication.component';
import {PartnerComponent} from './partner/partner.component';
import {PartnerService} from './partner/partner.service';
import {PartnerSelectComponent} from './partner/select/select.component';
import {ProgressComponent} from './progress/progress.component';
import {SegmentModule} from './segment/segment.module';
import {SegmentValidationDeleteComponent} from './segment/info/validation/delete/delete.component';
import {SigninComponent} from './signin/signin.component';
import {DmpStoreModule} from './store/store';
import {SwUpdateComponent} from './sw-update/sw-update.component';
import {UserService} from './user/user.service';
import {AuthInterceptor, PartnerInterceptor} from './utils/auth-interceptor';
import {SegmentMultiShareModule} from './segment-multi-share/segment-multi-share.module';
import {SegmentsModalWrapperComponent} from './segment-multi-share/modal-wrapper/segments-modal-wrapper.component';
import {Store} from '@ngrx/store';
import {GlobalStoreErrorHandlerService} from './utils/global-store-error-handler.service';
import {AuthService} from './auth/auth.service';
import {TaxonomyModule} from './taxonomy/taxonomy.module';
import {AuditLogsModule} from './audit-logs/audit-logs.module';
import {SynchronizationModule} from './synchronization/synchronization.module';
import {MultishareHistoryModule} from './segment-multi-share/multishare-history/multishare-history.module';
import {tryLoadInitialConfig} from './store/global.actions';

// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AuthGuardService,
  PartnerService,
  UserService,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: PartnerInterceptor,
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    useFactory: (store: Store, authService: AuthService) => {
      return () => {
        if (authService.isUserSignedIn()) {
          store.dispatch(tryLoadInitialConfig());
        }
      };
    },
    multi: true,
    deps: [Store, AuthService]
  },
  {
    provide: ErrorHandler,
    useClass: GlobalStoreErrorHandlerService,
  }
];


@NgModule({
  declarations: [
    ProgressComponent,
    AppComponent,
    PartnerComponent,
    HomeComponent,
    PartnerSelectComponent,
    NotificationComponent,
    SegmentValidationDeleteComponent,
    LogoutComponent,
    SigninComponent,
    SwUpdateComponent,
    ConfirmDialogComponent,
    SegmentsModalWrapperComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    DmpStoreModule,
    HttpClientModule,
    SharedModule,
    SegmentModule,
    SegmentMultiShareModule,
    DistributionAccountModule,
    DocumentationModule,
    TaxonomyModule,
    AuditLogsModule,
    SynchronizationModule,
    MultishareHistoryModule,
    ROUTES,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production})
  ],
  providers: [
    APP_PROVIDERS,
    HTTP_INTERCEPORTS
  ],
  exports: [],
  bootstrap: [
    AppComponent
  ]
})

export class AppModule {
}
